export default __webpack_public_path__ + "static/media/item_9_active.fd473e3b.png";